/** @format */

import { notificationConstants } from '../notifications/notifications';
import { reducerDebug } from '../../core/debug';

export type specializedReportType = {
    type?: string;
    collections?: any;
    item?: any;
    processSuccess?: boolean;
    success?: boolean;
    data?: any;
    deletedSuccess?: boolean;
    message?: string;
};

export const specializedReportConstants = {
    LIST: 'specialized_report_list',
    ITEM: 'specialized_report_item',
    EDIT: 'specialized_report_edit',
    DELETE: 'specialized_report_delete',
    MANAGE: 'specialized_report_manage',
    ADD: 'specialized_report_add',
};

export function specializedReportReducers(state = {}, action: specializedReportType): object {
    reducerDebug('Specialized reports reducer: ' + action.type);
    switch (action.type) {
        case specializedReportConstants.LIST:
            return {
                ...state,
                type: action.type,
                collections: action.collections,
            };
        case specializedReportConstants.ITEM:
            return {
                ...state,
                type: action.type,
                item: action.item,
            };
        case specializedReportConstants.ADD:
        case specializedReportConstants.EDIT:
            return {
                ...state,
                type: action.type,
                success: true,
                data: action.data,
            };
        case specializedReportConstants.DELETE:
            return {
                ...state,
                type: action.type,
                deletedSuccess: true,
            };
        case notificationConstants.ERROR:
            return {
                type: action.type,
                message: action.message,
            };
        default:
            return {
                ...state,
            };
    }
}
